/**
 * Kampagnen-Zuordnung: merkt sich die UTM-Parameter der Anzeige (utm_source, utm_medium, utm_campaign,
 * utm_content, utm_term) und liefert sie als Tags für das Warteliste-Formular, z. B. „utm-campaign-s1_haut“.
 * Gespeichert wird nur im Browser (30 Tage), nichts Persönliches, und nur mit Einwilligung im Cookie-Banner
 * (Statistik oder Marketing, Shopify Customer Privacy API; § 25 TDDDG). Ohne Einwilligung zählt nur die aktuelle Adresse,
 * und ein früher gespeicherter Wert wird gelöscht.
 */
(() => {
  const FELDER = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const SCHLUESSEL = 'etapa-quelle';
  const TAGE = 30;

  const sauber = (wert) =>
    String(wert)
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);

  const ausAdresse = () => {
    const parameter = new URLSearchParams(window.location.search);
    const treffer = {};
    for (const feld of FELDER) {
      const wert = parameter.get(feld);
      if (wert) treffer[feld] = sauber(wert);
    }
    return treffer;
  };

  const lesen = () => {
    try {
      const roh = window.localStorage.getItem(SCHLUESSEL);
      if (!roh) return {};
      const gespeichert = JSON.parse(roh);
      if (!gespeichert.bis || gespeichert.bis < Date.now()) return {};
      return gespeichert.werte || {};
    } catch {
      return {};
    }
  };

  const schreiben = (werte) => {
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify({ werte, bis: Date.now() + TAGE * 86400000 }));
    } catch {
      /* Speicher gesperrt: ignorieren */
    }
  };

  const erlaubt = () => {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      return Boolean(cp.analyticsProcessingAllowed?.() || cp.marketingAllowed?.());
    } catch {
      return false;
    }
  };

  const neu = ausAdresse();
  const anwenden = () => {
    if (erlaubt()) {
      if (Object.keys(neu).length > 0) schreiben(neu);
    } else {
      try {
        window.localStorage.removeItem(SCHLUESSEL);
      } catch {
        /* Speicher gesperrt: ignorieren */
      }
    }
  };

  try {
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (fehler) => {
      if (!fehler) anwenden();
    });
  } catch {
    /* ohne Consent-API: nichts speichern */
  }
  document.addEventListener('visitorConsentCollected', anwenden);

  window.EtapaQuelle = {
    tags() {
      const werte = { ...(erlaubt() ? lesen() : {}), ...ausAdresse() };
      return FELDER.filter((feld) => werte[feld]).map((feld) => `${feld.replace('_', '-')}-${werte[feld]}`);
    },
  };
})();
